module.exports = {"440606003":"伦教街道","440606004":"勒流街道","440606005":"大良街道","440606006":"容桂街道","440606101":"陈村镇","440606102":"北滘镇","440606103":"乐从镇","440606104":"龙江镇","440606105":"杏坛镇","440606106":"均安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440606.json
// module id = 1813
// module chunks = 0